(function() {
  'use strict';

  angular
    .module('livExtendedStay',
    [
        'ngMessages',
        'ui.router',
        'googleService',
        'contentService',
        'slickCarousel'
    ]);

})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('LocalPartnersController', LocalPartnersController);

    /** @ngInject */
    function LocalPartnersController(IMAGE_ABS_URL, sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;
        var section_images = sectionData.section_images;

        // view
        vm.banner = '';
        vm.local_partners = [];
        vm.section_text = {
            title: '',
            subtitle: '',
            description: ''
        };

        // functions
        init();

        function init() {
            setBanner();
            setSectionText();
            setupLocalPartners();
        }

        // set banner url
        function setBanner() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'banner') {
                    vm.banner = IMAGE_ABS_URL + section_images[i].url;
                    break;
                }
            }
        }

        // set section title, subtitle, description
        function setSectionText() {
            for (var i = 0; i < section_content.length; i++) {
                switch (section_content[i].name) {
                    case 'title':
                        vm.section_text.title = section_content[i].content;
                        break;
                    case 'description':
                        vm.section_text.description = section_content[i].content;
                        break;
                }
            }
        }

        // setup liv local partners
        function setupLocalPartners() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'partners') {
                    var partner = {
                        image_url: IMAGE_ABS_URL + section_images[i].url.replace(/\s/g, '%20'),
                        description: section_images[i].title,
                        url: section_images[i].caption
                    };
                    vm.local_partners.push(partner);
                }
            }
        }

    }
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('SuitesController', SuitesController);

    /** @ngInject */
    function SuitesController($timeout, IMAGE_ABS_URL, sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;
        var section_filters = sectionData.section_filters;
        var section_images = sectionData.section_images;
        var section_points = sectionData.section_points;

        // view
        vm.banner = null;
        vm.bedrooms = [];
        vm.features = [];
        vm.rates = [];
        vm.rates_title = '';
        vm.rates_description = '';
        vm.suite_features = '';
        vm.title = '';
        vm.termsPDF = '';

        // variables


        // functions
        vm.showFloorplans = showFloorplans;

        init();

        function init() {
            getBanner();
            setTitles();
            getSuites();
            getFeatures();
            getRates();
            getTermsPDF();
        }

        // get banner image
        function getBanner() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'banner') {
                    vm.banner = IMAGE_ABS_URL + section_images[i].url;
                    break;
                }
            }
        }

        // get feature icons
        function getFeatures() {
            var i;

            // set features array
            for (i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'feature') {
                    var feature = {
                        url: IMAGE_ABS_URL + section_images[i].url,
                        name: section_images[i].title
                    };
                    vm.features.push(feature);
                }
            }

            // set features list
            for (i = 0; i < section_content.length; i++) {
                if (section_content[i].name === 'features') {
                    vm.suite_features = section_content[i].content;
                    break;
                }
            }
        }

        // get rates
        function getRates() {
            var i;
            var rates_filter;
            for (i = 0; i < section_filters.length; i++) {
                if (section_filters[i].filter_name === 'RATES') {
                    rates_filter = section_filters[i].id;
                    break;
                }
            }

            for (i = 0; i < section_points.length; i++) {
                if (section_points[i].filter_id === rates_filter) {
                    var rate = {
                        type: section_points[i].name,
                        description: section_points[i].description
                    };
                    vm.rates.push(rate);
                }
            }

            // set rates description
            for (i = 0; i < section_content.length; i++) {
                if (section_content[i].name === 'rates') {
                    vm.rates_description = section_content[i].content;
                    break;
                }
            }
        }

        // populate suite info
        function getSuites() {
            // create bedrooms
            var bedrooms = [];
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'bed') {
                    var type = section_images[i].caption;
                    var room = { images: [], type: type };
                    for (var j = 0; j < section_images.length; j++) {
                        if (section_images[j].type == type) {
                            room.images.push(section_images[j]);
                            var image_url = IMAGE_ABS_URL + room.images[room.images.length - 1].url;
                            var last = room.images.length - 1;
                            room.images[last].url = image_url;
                            room.images[last].caption = room.images[last].title + '<br /><span size18>' + room.images[last].caption + '</span>';
                        }
                    }
                    room.num = section_images[i].title.substring(0,1);
                    room.title = section_images[i].title.replace(room.num, '');
                    room.url = IMAGE_ABS_URL + section_images[i].url;
                    bedrooms.push(room);
                }
            }
            bedrooms.sort(function(a,b) { return a.order - b.order; });
            vm.bedrooms = bedrooms;

            // init the images
            $timeout(function() {

            });
        }

        // get terms pdf
        function getTermsPDF() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'terms') {
                    vm.termsPDF = IMAGE_ABS_URL + section_images[i].url;
                    break;
                }
            }
        }

        // set titles
        function setTitles() {
            for (var i = 0; i < section_content.length; i++) {
                if (section_content[i].name === 'title') {
                    vm.title = section_content[i].content;
                } else if (section_content[i].name === 'rates_title') {
                    vm.rates_title = section_content[i].content;
                }
            }
        }

        // show floorplans when clicked
        function showFloorplans(type) {
            angular.element('[type="' + type + '"] a').simpleLightbox({ closeText: '&times;', loop: false, history: false }).open();
            return false;
        }

    }
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('TermsController', TermsController);

    /** @ngInject */
    function TermsController(sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;

        // view
        vm.terms = '';

        // functions

        init();

        function init() {
            for (var i = 0; i < section_content.length; i++) {
                if (section_content[i].name === 'terms') {
                    vm.terms = section_content[i].content;
                    break;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('ServicesController', ServicesController);

    /** @ngInject */
    function ServicesController(IMAGE_ABS_URL, sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;
        var section_images = sectionData.section_images;

        // view
        vm.banner = '';
        vm.services_cards = [];
        vm.section_text = {
            title: '',
            subtitle: '',
            description: ''
        };

        // functions
        init();

        function init() {
            setBanner();
            setSectionText();
            setCards();
        }

        // set section banner
        function setBanner() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'banner') {
                    vm.banner = IMAGE_ABS_URL + section_images[i].url;
                    break;
                }
            }
        }

        // set amenities cards
        function setCards() {
            var services_cards = [];
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'card') {
                    services_cards.push(section_images[i]);
                    var last = services_cards.length - 1;
                    services_cards[last].url = IMAGE_ABS_URL + services_cards[last].url;
                }
            }

            // sort cards by imageset_id
            services_cards.sort(function(a,b) {
                return parseInt(a.imageset_id) - parseInt(b.imageset_id);
            });

            vm.services_cards = services_cards;
        }

        // set section title, subtitle, description
        function setSectionText() {
            for (var i = 0; i < section_content.length; i++) {
                switch (section_content[i].name) {
                    case 'title':
                        vm.section_text.title = section_content[i].content;
                        break;
                    case 'subtitle':
                        vm.section_text.subtitle = section_content[i].content;
                        break;
                    case 'description':
                        vm.section_text.description = section_content[i].content;
                        break;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('ReviewsController', ReviewsController);

    /** @ngInject */
    function ReviewsController(IMAGE_ABS_URL, sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;
        var section_images = sectionData.section_images;
        var section_points = sectionData.section_points;

        // view
        vm.banner = '';
        vm.services_cards = [];
        vm.section_text = {
            title: '',
            subtitle: '',
            description: ''
        };
        vm.reviews = [];

        // variables
        vm.slickConfig = {
            autoplay: false,
            dots: false,
            speed: 500,
            arrows: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow: '<a class="review-prev"><i class="material-icons">keyboard_arrow_left</i></a>',
            nextArrow: '<a class="review-next"><i class="material-icons">keyboard_arrow_right</i></a>',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        // functions
        init();

        function init() {
            setBanner();
            setSectionText();
            initReviews();
        }

        // format reviews
        function initReviews() {
            for (var i = 0; i < section_points.length; i++) {
                var review = {
                    name: section_points[i].name,
                    text: section_points[i].description
                };
                vm.reviews.push(review);
            }
        }

        // set section banner
        function setBanner() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'banner') {
                    vm.banner = IMAGE_ABS_URL + section_images[i].url;
                    break;
                }
            }
        }

        // set section title, subtitle, description
        function setSectionText() {
            for (var i = 0; i < section_content.length; i++) {
                switch (section_content[i].name) {
                    case 'title':
                        vm.section_text.title = section_content[i].content;
                        break;
                    case 'subtitle':
                        vm.section_text.subtitle = section_content[i].content;
                        break;
                    case 'description':
                        vm.section_text.description = section_content[i].content;
                        break;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('MeetingsController', MeetingsController);

    /** @ngInject */
    function MeetingsController(IMAGE_ABS_URL, sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;
        var section_images = sectionData.section_images;

        // view
        vm.amenities_cards = [];
        vm.amenities_cards_sky = [];
        vm.section_text = {
            title: '',
            subtitle: '',
            description: '',
            skyDivider: '',
            skyTitle: '',
            skyDescription: '',
            skyList: ''
        };
        vm.keyplate = '';

        // variables

        // functions
        init();

        function init() {
            setBanner();
            setSectionText();
            setCards();
        }

        // set section banner
        function setBanner() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'banner') {
                    vm.banner = IMAGE_ABS_URL + section_images[i].url;
                }
                else if (section_images[i].type === 'keyplate') {
                    vm.keyplate = IMAGE_ABS_URL + section_images[i].url;
                }
            }
        }

        // set amenities cards
        function setCards() {
            var amenities_cards = [];
            var amenities_cards_sky = [];
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'card') {
                    amenities_cards.push(section_images[i]);
                    var last = amenities_cards.length - 1;
                    amenities_cards[last].url = IMAGE_ABS_URL + amenities_cards[last].url;
                }
                if (section_images[i].type === 'sky_card') {
                  amenities_cards_sky.push(section_images[i]);
                  var last_sky = amenities_cards_sky.length - 1;
                  amenities_cards_sky[last_sky].url = IMAGE_ABS_URL + amenities_cards_sky[last_sky].url;
                }
            }

            // sort cards by imageset_id
            amenities_cards.sort(function(a,b) {
                return parseInt(a.imageset_id) - parseInt(b.imageset_id);
            });

            // sort cards by imageset_id
            amenities_cards_sky.sort(function (a, b) {
                return parseInt(a.imageset_id) - parseInt(b.imageset_id);
            });

            vm.amenities_cards = amenities_cards;
            vm.amenities_cards_sky = amenities_cards_sky;
        }

        // set section title, subtitle, description
        function setSectionText() {
            for (var i = 0; i < section_content.length; i++) {
                switch (section_content[i].name) {
                    case 'title':
                        vm.section_text.title = section_content[i].content;
                        break;
                    case 'subtitle':
                        vm.section_text.subtitle = section_content[i].content;
                        break;
                    case 'description':
                        vm.section_text.description = section_content[i].content;
                        break;
                    case 'sky_divider':
                         vm.section_text.skyDivider = section_content[i].content;
                         break;
                    case 'sky_title':
                        vm.section_text.skyTitle = section_content[i].content;
                        break;
                    case 'sky_desc':
                        vm.section_text.skyDescription = section_content[i].content;
                        break;
                    case 'sky_list':
                        vm.section_text.skyList = section_content[i].content;
                        break;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('MainController', MainController);

    /** @ngInject */
    function MainController($sce, $timeout, IMAGE_ABS_URL, sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;
        var section_images = sectionData.section_images;

        // view
        vm.images = [];
        vm.carousel_images = getCarouselImages();
        vm.content = '';
        vm.video = {};
        vm.promotion_view = false;

        // variables
        var lightbox;
        vm.slickConfig = {
            autoplay: true,
            dots: true,
            speed: 800,
            arrows: false,
            infinite: true,
            autoplaySpeed: 8000
        };
        vm.promotion;

        // functions
        vm.togglePromotion = togglePromotion;
        init();

        function init() {
            initContent();
            initMedia();
            $timeout(togglePromotion, 2000);
        }

        // get section carousel images
        function getCarouselImages() {
            var carousel_array = [];
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'carousel') {
                    carousel_array.push(IMAGE_ABS_URL + section_images[i].url);
                }
            }
            carousel_array.sort(function(a,b) {
                return parseInt(a.imageset_id) - parseInt(b.imageset_id);
            });
            return carousel_array;
        }

        // display section content
        function initContent() {
            // fetch description
            for (var i = 0; i < section_content.length; i++) {
              switch (section_content[i].name) {
                case 'content':
                  vm.content += section_content[i].content;
                  break;
                case 'promotion':
                  vm.promotion = section_content[i].content;
                  break;
              }
            }
        }

        // init video + images
        function initMedia() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'image') {
                    var image = {
                        order: section_images[i].imageset_id,
                        url: IMAGE_ABS_URL + section_images[i].url,
                        thumb_url: IMAGE_ABS_URL + section_images[i].thumb_url
                    };

                    vm.images.push(image);
                } else if (section_images[i].type === 'playlist') {
                    var yt_url = section_images[i].url;
                    yt_url = yt_url.replace('watch?v=', 'embed/');
                    yt_url = yt_url.replace('index=1', 'index=0');
                    yt_url = yt_url.replace('&', '?');
                    //yt_url += '&loop=1&autoplay=1';
                    vm.video.url = $sce.trustAsResourceUrl(yt_url);
                }
            }
            vm.images.sort(function(a,b) {
                return parseInt(a.order) - parseInt(b.order);
            });

            $timeout(function() {
                lightbox = angular.element('.images-row a').simpleLightbox({
                    closeText: '&times;',
                    loop: false,
                    history: false,
                    widthRatio : 1.0,
                    heightRatio :1.0
                });

                // mute youtube audio
                var yt_video = document.getElementById('home-yt');
                initYouTube();
            });
        }

        function initYouTube() {
            var player = new YT.Player('yt-container', {
                playerVars: {
                    'autoplay': 1,
                    'controls': 1,
                    'loop': 1,
                    'mute': 1,
                    'playlist': vm.video.url
                },
                videoId: vm.video.url,
                events: {
                    'onReady': function(event) {
                        event.target.playVideo();
                        event.target.mute();
                    }
                }
            });
        }

        function togglePromotion() {
          vm.promotion_view = !vm.promotion_view;
        }

    }
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('LocationController', LocationController);

    /** @ngInject */
    function LocationController($document, $timeout, $scope, $window, locationData, IMAGE_ABS_URL, sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;
        var section_images = sectionData.section_images;
        var section_points = sectionData.section_points;
        var location_filters = locationData.section_filters;
        var location_points = locationData.section_points;

        // view
        vm.banner = '';
        vm.current_filter = null;
        vm.current_images = [];
        vm.filters = {};
        vm.keytag = '';
        vm.liv_local = {};
        vm.partners = [];
        vm.section_text = {
            title: '',
            subtitle: '',
            description: ''
        };
        vm.walk_score_button = {};
        vm.walk_scores = [];

        // variables
        var counted = false;
        var geocoder;
        var google_map_style = [
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#6eb2c8"}
                ]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#7b7979"}
                ]
            }, {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#e2eb82"}
                ]
            }, {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#f8f8f8"}
                ]
            }, {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#eff0f0"}
                ]
            }, {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#eff0f0"}
                ]
            }
        ];
        var infowindow;
        var map;
        var markers = [];
        var WALK_SCORE_LABEL = '207-bell-st-n-ottawa-on-canada';

        // functions
        vm.clearFilter = clearFilter;
        vm.selectFilter = selectFilter;

        init();

        function init() {
            setBanner();
            setSectionText();
            setupLocationFilters();
            initGoogleMap();
            getPartners();
        }

        // clear map filters
        function clearFilter() {
            vm.current_filter = null;
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(map);
            }
        }

        // code current location address
        function codeAddress() {
            var address = "207 Bell Street North Ottawa, ON K1R 0B9";
            geocoder.geocode({'address': address}, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    var liv_icon = {
                        url: 'assets/images/liv-marker.png',
                        scaledSize: new google.maps.Size(80, 75),
                        origin: new google.maps.Point(0,0),
                        anchor: new google.maps.Point(40, 37)
                    };
                    new google.maps.Marker({
                        map: map,
                        icon: liv_icon,
                        position: results[0].geometry.location
                    });
                    map.setCenter(results[0].geometry.location);
                } else {
                    alert("Geocode was not successful for the following reason: " + status);
                }
            });
            createMarkers();
        }

        // create marker array
        function createMarkers() {
            /* now inside your initialise function */
            infowindow = new google.maps.InfoWindow({
                content: "holding..."
            });

            for (var i = 0; i < location_points.length; i++) {
                //console.log("Marker:" + markerArray[i].x + "," + markerArray[i].y);
                var pos = new google.maps.LatLng(location_points[i].x, location_points[i].y);
                var marker_img = {
                    url: 'http://livottawa.com/images/icons/pin.png',
                    scaledSize: new google.maps.Size(32, 51),
                    origin: new google.maps.Point(0,0),
                    anchor: new google.maps.Point(16, 51)
                };
                var marker = new google.maps.Marker({
                    map: map,
                    position: pos,
                    animation: google.maps.Animation.DROP,
                    title: location_points[i].name,
                    icon: marker_img
                });
                marker.info = location_points[i];

                google.maps.event.addListener(marker, 'click', selectMarker.bind(vm, marker));

                markers.push(marker);
            }

            formatWalkScores();
        }

        // format walk scores + walk score button on bottom right
        function formatWalkScores() {
            // format walk scores
            for (var i = 0; i < section_points.length; i++) {
                if (section_points[i].filter_id === '1') {
                    var score = {
                        image_url: 'assets/images/' + section_points[i].name + '.png',
                        title: section_points[i].description,
                        description: section_points[i].link,
                        score: parseInt(section_points[i].x)
                    };
                    vm.walk_scores.push(score);
                }
            }

            // format walk score button on bottom right
            vm.walk_score_button.label = WALK_SCORE_LABEL;
            vm.walk_score_button.url = 'https://www.walkscore.com/score/' + WALK_SCORE_LABEL + '?utm_source=badge&utm_medium=responsive&utm_campaign=badge';
            vm.walk_score_button.image_url = 'http://pp.walk.sc/badge/walk/' + WALK_SCORE_LABEL + '.svg';

            $timeout(function() {
                angular.element($window).bind('scroll', function() {
                    if (counted) return;
                    if (this.pageYOffset >= 200) {
                        var scores = angular.element('.walk-score-image-label');
                        for (var i = 0; i < scores.length; i++) {
                            var score = parseInt(angular.element(scores[i]).html());
                            angular.element(scores[i]).countTo({
                                from: 0,
                                to: score,
                                speed: 1500,
                                refreshInterval: 50
                            });
                        }
                        counted = true;
                    }
                });
                $scope.$digest();
            });
        }

        // setup liv local partners
        function getPartners() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'partners') {
                    var partner = {
                        image_url: IMAGE_ABS_URL + section_images[i].url,
                        description: section_images[i].title,
                        url: section_images[i].caption
                    };
                    vm.partners.push(partner);
                } else if (section_images[i].type === 'keytag') {
                    vm.keytag = IMAGE_ABS_URL + section_images[i].url;
                }
            }
        }

        // initialize google maps
        function initGoogleMap() {
            geocoder = new google.maps.Geocoder();

            var myOptions = {
                mapTypeControlOptions: {
                    mapTypeIds: ['Styled']
                },
                zoom: 16,
                scrollwheel: false,
                panControl: false,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                overviewMapControl: false,
                mapTypeId: 'Styled'
            };

            map = new google.maps.Map($document.find('#location-map')[0], myOptions);

            var styledMapType = new google.maps.StyledMapType(google_map_style, {name: 'Styled'});
            map.mapTypes.set('Styled', styledMapType);

            codeAddress();
        }

        // select filters
        function selectFilter(filter_id) {
            vm.current_filter = filter_id;

            for (var i = 0; i < markers.length; i++) {
                if (markers[i].info.filter_id == vm.current_filter) {
                    markers[i].setMap(map);
                } else {
                    markers[i].setMap(null);
                }
            }
        }

        // google map marker click
        function selectMarker(marker) {
            var show_hide = 'none';
            if (marker.info.link !== '')
            show_hide = 'block';

            var iw_template = '<div class="infowindow">' +
            '<div><strong>' + marker.info.name + '</strong></div>' +
            '<div>' + marker.info.description + '</div>' +
            '<div style="display:' + show_hide + '"><a href="' + marker.info.link + '" target="_blank">View Website</a></div></div>';

            infowindow.setContent(iw_template);
            infowindow.open(map, marker);
        }

        // set banner url
        function setBanner() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'banner') {
                    vm.banner = IMAGE_ABS_URL + section_images[i].url;
                    break;
                }
            }
        }

        // set section title, subtitle, description
        function setSectionText() {
            for (var i = 0; i < section_content.length; i++) {
                switch (section_content[i].name) {
                    case 'title':
                        vm.section_text.title = section_content[i].content;
                        break;
                    case 'subtitle':
                        vm.section_text.subtitle = section_content[i].content;
                        break;
                    case 'description':
                        vm.section_text.description = section_content[i].content;
                        break;
                    case 'secondary_title':
                        vm.liv_local.title = section_content[i].content;
                        break;
                    case 'secondary_description':
                        vm.liv_local.description = section_content[i].content;
                        break;
                }
            }
        }

        // setup location filters
        function setupLocationFilters() {
            for (var i = 0; i < location_filters.length; i++) {
                var filter_key = location_filters[i].id;
                vm.filters[filter_key] = location_filters[i].filter_name;
            }

        }
    }

    // custom plugin for counting numbers up
    (function($) {
        $.fn.countTo = function(options) {
            // merge the default plugin settings with the custom options
            options = $.extend({}, $.fn.countTo.defaults, options || {});

            // how many times to update the value, and how much to increment the value on each update
            var loops = Math.ceil(options.speed / options.refreshInterval),
            increment = (options.to - options.from) / loops;

            return $(this).each(function() {
                var _this = this,
                loopCount = 0,
                value = options.from,
                interval = setInterval(updateTimer, options.refreshInterval);

                function updateTimer() {
                    value += increment;
                    loopCount++;
                    $(_this).html(value.toFixed(options.decimals));

                    if (typeof(options.onUpdate) == 'function') {
                        options.onUpdate.call(_this, value);
                    }

                    if (loopCount >= loops) {
                        clearInterval(interval);
                        value = options.to;

                        if (typeof(options.onComplete) == 'function') {
                            options.onComplete.call(_this, value);
                        }
                    }
                }
            });
        };

        $.fn.countTo.defaults = {
            from: 0,  // the number the element should start at
            to: 100,  // the number the element should end at
            speed: 1000,  // how long it should take to count between the target numbers
            refreshInterval: 100,  // how often the element should be updated
            decimals: 0,  // the number of decimal places to show
            onUpdate: null,  // callback method for every time the element is updated,
            onComplete: null,  // callback method for when the element finishes updating
        };
    })(jQuery);
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('GalleryController', GalleryController);

    /** @ngInject */
    function GalleryController($timeout, galleryImages, IMAGE_ABS_URL, sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;
        var section_images = sectionData.section_images;
        var gallery_images = galleryImages.section_images;
        var gallery_filters = galleryImages.section_filters;

        // view
        vm.banner = '';
        vm.current_filter = null;
        vm.current_images = [];
        vm.filters = {};
        vm.gallery = [];
        vm.section_text = {
            title: '',
            subtitle: '',
            description: ''
        };
        vm.videos = [];

        // variables
        var lightbox;
        var video_lightbox;
        vm.slickConfig = {
            autoplay: false,
            dots: false,
            speed: 500,
            arrows: true,
            infinite: false,
            autoplaySpeed: 8000,
            slidesToShow: 3,
            slidesToScroll: 3,
            prevArrow: '<a class="videos-prev"><i class="material-icons">keyboard_arrow_left</i></a>',
            nextArrow: '<a class="videos-next"><i class="material-icons">keyboard_arrow_right</i></a>',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        // functions
        vm.selectFilter = selectFilter;
        vm.selectVideo = selectVideo;

        init();

        function init() {
            setBanner();
            setSectionText();
            initVideos();
            initGallery();
            initTooltips();
        }

        // sort and filter gallery images
        function initGallery() {
            setupFilters();
            organizeImages();
        }

        // init bootstrap tooltips
        function initTooltips() {
            $timeout(function() {
                angular.element('[data-toggle="tooltip"]').tooltip();
                angular.element(document).on('mousemove', '.gallery-images img', function(event) {
                    angular.element('.image-tooltip').css({top: event.pageY, left: event.pageX });
                    angular.element('.image-tooltip').tooltip('show');
                });

                angular.element(document).on('mouseleave', '.gallery-images img', function(event) {
                    angular.element('.image-tooltip').tooltip('hide');
                });
            }, 500);
        }

        // get videos from gallery
        function initVideos() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'video') {
                    var video = {};
                    video.order = parseInt(section_images[i].imageset_id);
                    video.url = section_images[i].url;
                    var index = video.url.indexOf('v=');
                    var code = video.url.substring(index + 2, video.url.length);
                    video.thumb_url = 'http://img.youtube.com/vi/' + code + '/0.jpg';
                    video.url += '&rel=0';
                    vm.videos.push(video);
                }
            }

            // sort videos based on order
            vm.videos.sort(function(a,b) {
                return a.order - b.order;
            });
        }

        // show suites
        function organizeImages() {
            var i, image, prop;
            // liv ottawa images
            var filter_id_array = ['581', '586'];
            for (i = 0; i < gallery_images.length; i++) {
                if (gallery_images[i].type === 'full_kiosk' &&
                    filter_id_array.indexOf(gallery_images[i].filter_id) > -1) {
                    image = {};
                    for (prop in gallery_images[i]) {
                        image[prop] = gallery_images[i][prop];
                    }
                    if (image.filter_id === '580') {
                        image.filter_id = '579';
                    }
                    image.type = 'gallery';
                    image.url = IMAGE_ABS_URL + image.url;
                    image.thumb_url = IMAGE_ABS_URL + image.thumb_url;
                    image.full_url = IMAGE_ABS_URL + image.full_url;
                    vm.gallery.push(image);
                }
            }

            // liv extended stay gallery - add own gallery images
            for (i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'gallery') {
                    image = {};
                    for (prop in section_images[i]) {
                        image[prop] = section_images[i][prop];
                    }
                    if (image.filter_id === '580') {
                        image.filter_id = '579';
                    }
                    image.url = IMAGE_ABS_URL + image.url;
                    image.thumb_url = IMAGE_ABS_URL + image.thumb_url;
                    vm.gallery.push(image);
                }
            }
            $timeout(function() {
                selectFilter(vm.filters.suites.id);
            });
        }

        // select gallery filter
        function selectFilter(filter) {
            vm.current_filter = filter;
            angular.element('.gallery-images').removeClass('loaded');

            $timeout(function() {
                // select image based on filter
                vm.current_images = [];
                for (var i = 0; i < vm.gallery.length; i++) {
                    if (vm.gallery[i].filter_id === vm.current_filter || vm.current_filter == vm.filters.all.id) {
                        vm.current_images.push(vm.gallery[i]);
                    }
                }

                if (vm.current_filter == vm.filters.all.id) {
                    shuffleArray(vm.current_images);
                }

                if (lightbox) {
                    lightbox.destroy();
                }

                $timeout(function() {
                    lightbox = angular.element('.gallery-images a').simpleLightbox({
                        closeText: '&times;',
                        loop: false,
                        history: false,
                        widthRatio : 1.0,
                        heightRatio :1.0
                    });
                    angular.element('.gallery-images').addClass('loaded');
                });
            }, 250);
        }

        // open video in lightbox
        function selectVideo(index) {
            if (video_lightbox) {
                video_lightbox.close();
            }
            video_lightbox = lity(vm.videos[index].url);
        }

        // set banner url
        function setBanner() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'banner') {
                    vm.banner = IMAGE_ABS_URL + section_images[i].url;
                    break;
                }
            }
        }

        // set section title, subtitle, description
        function setSectionText() {
            for (var i = 0; i < section_content.length; i++) {
                switch (section_content[i].name) {
                    case 'title':
                        vm.section_text.title = section_content[i].content;
                        break;
                    case 'subtitle':
                        vm.section_text.subtitle = section_content[i].content;
                        break;
                    case 'description':
                        vm.section_text.description = section_content[i].content;
                        break;
                }
            }
        }

        // setup gallery filters
        function setupFilters() {
            // sort filters first
            gallery_filters.sort(function(a,b) {
                return parseInt(a.order_id) - parseInt(b.order_id);
            });

            for (var i = 0; i < gallery_filters.length; i++) {
                if (gallery_filters[i].order_id === '0' || gallery_filters[i].id === '580') { continue; }
                var filter_name = gallery_filters[i].filter_name;
                vm.filters[filter_name.toLowerCase()] = {};
                vm.filters[filter_name.toLowerCase()].id = gallery_filters[i].id;
                vm.filters[filter_name.toLowerCase()].name = filter_name;
                if (gallery_filters[i].id === '579') {
                    vm.filters[filter_name.toLowerCase()].name = 'Suites & Amenities';
                }
            }

            $timeout(function() {
                vm.current_filter = vm.filters.suites;
                lightbox = angular.element('.gallery-images a').simpleLightbox({
                    closeText: '&times;',
                    loop: false,
                    history: false,
                    widthRatio : 1.0,
                    heightRatio :1.0
                });
                angular.element('.gallery-images').addClass('loaded');
            });
        }

        // shuffle image array
        function shuffleArray(array) {
            var current_index = array.length,
                temp_value,
                random_index;

            while (current_index !== 0) {
                random_index = Math.floor(Math.random() * current_index);
                current_index -= 1;

                // swap with current element
                temp_value = array[current_index];
                array[current_index] = array[random_index];
                array[random_index] = temp_value;
            }

            return array;
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('FAQController', FAQController);

    /** @ngInject */
    function FAQController(IMAGE_ABS_URL, sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;
        var section_images = sectionData.section_images;
        var section_filters = sectionData.section_filters;
        var section_points = sectionData.section_points;

        // view
        vm.banner = '';
        vm.questions = [];
        vm.section_text = {
            title: '',
            subtitle: '',
            description: ''
        };

        // functions
        init();

        function init() {
            setBanner();
            setSectionText();
            setupQuestions();
        }

        // set banner url
        function setBanner() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'banner') {
                    vm.banner = IMAGE_ABS_URL + section_images[i].url;
                    break;
                }
            }
        }

        // set section title, subtitle, description
        function setSectionText() {
            for (var i = 0; i < section_content.length; i++) {
                switch (section_content[i].name) {
                    case 'title':
                        vm.section_text.title = section_content[i].content;
                        break;
                    case 'subtitle':
                        vm.section_text.subtitle = section_content[i].content;
                        break;
                    case 'description':
                        vm.section_text.description = section_content[i].content;
                        break;
                    case 'secondary_title':
                        vm.liv_local.title = section_content[i].content;
                        break;
                    case 'secondary_description':
                        vm.liv_local.description = section_content[i].description;
                        break;
                }
            }
        }

        // setup questions
        function setupQuestions() {
            var i, j;

            // sort faq filters
            section_filters.sort(function(a,b) {
                return parseInt(a.order_id) - parseInt(b.order_id);
            });

            // create faq sections
            for (i = 0; i < section_filters.length; i++) {
                var section = {
                    filter_id: section_filters[i].id,
                    title: section_filters[i].filter_name,
                    questions: []
                };
                vm.questions.push(section);
            }

            // add questions into each section
            for (i = 0; i < section_points.length; i++) {
                var question = {
                    order_id: section_points[i].order_id,
                    q: section_points[i].name,
                    a: section_points[i].description
                };
                for (j = 0; j < vm.questions.length; j++) {
                    if (vm.questions[j].filter_id === section_points[i].filter_id) {
                        vm.questions[j].questions.push(question);
                    }
                }
            }

            // sort questions
            for (i = 0; i < vm.questions.length; i++) {
                vm.questions[i].questions.sort(sortQuestions.bind(null, 'order_id'));
            }
        }

        // sort questions
        function sortQuestions(prop) {
            return function(a,b) {
                if (a && b) {
                    return parseInt(a[prop]) - parseInt(b[prop]);
                }
            };
        }
    }
})();

(function() {
  'use strict';

  angular
  .module('livExtendedStay')
  .controller('CLVGroupReviewsController', CLVGroupReviewsController);

  /** @ngInject */
  function CLVGroupReviewsController(IMAGE_ABS_URL, sectionData) {
    var vm = this;

    // model
    var section_content = sectionData.section_content;
    var section_images = sectionData.section_images;
    var section_filters = sectionData.section_filters;
    var section_points = sectionData.section_points;

    // view
    vm.banner = '';
    vm.questions = [];
    vm.section_text = {
      title: '',
      subtitle: '',
      description: ''
    };

    // functions
    init();

    function init() {
      setBanner();
      setSectionText();
    }

    // set banner url
    function setBanner() {
      for (var i = 0; i < section_images.length; i++) {
        if (section_images[i].type === 'banner') {
          vm.banner = IMAGE_ABS_URL + section_images[i].url;
          break;
        }
      }
    }

    // set section title, subtitle, description
    function setSectionText() {
      for (var i = 0; i < section_content.length; i++) {
        switch (section_content[i].name) {
          case 'title':
            vm.section_text.title = section_content[i].content;
            break;
          case 'subtitle':
            vm.section_text.subtitle = section_content[i].content;
            break;
          case 'description':
            vm.section_text.description = section_content[i].content;
            break;
          case 'secondary_title':
            vm.liv_local.title = section_content[i].content;
            break;
          case 'secondary_description':
            vm.liv_local.description = section_content[i].description;
            break;
        }
      }
    }
  }
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('ContactController', ContactController);

    /** @ngInject */
    function ContactController($document, $timeout, IMAGE_ABS_URL, sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;
        var section_images = sectionData.section_images;

        // view
        vm.banner = '';
        vm.contact_info = '';
        vm.section_text = {
            title: '',
            subtitle: '',
            description: ''
        };

        // styles
        var geocoder;
        var map;
        var map_style = [
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#6eb2c8"}
                ]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#7b7979"}
                ]
            }, {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#e2eb82"}
                ]
            }, {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#f8f8f8"}
                ]
            }, {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#eff0f0"}
                ]
            }, {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {"color": "#eff0f0"}
                ]
            }
        ];

        // functions
        init();

        function init() {
            setBanner();
            setSectionText();
            initContactMap();
            setupRegForm();
        }

        // show liv marker
        function codeAddress() {
            var address = "207 Bell St N, Ottawa, ON";
            geocoder.geocode({'address': address}, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    var liv_icon = {
                        url: 'assets/images/liv-marker.png',
                        scaledSize: new google.maps.Size(80, 75),
                        origin: new google.maps.Point(0,0),
                        anchor: new google.maps.Point(40, 37)
                    };
                    new google.maps.Marker({
                        map: map,
                        icon: liv_icon,
                        position: results[0].geometry.location
                    });

                    map.setCenter(results[0].geometry.location);
                } else {
                    console('Geocode was not successful for the following reason: ' + status);
                }
            });
        }

        // initialize contact map
        function initContactMap() {
            geocoder = new google.maps.Geocoder();

            var myOptions = {
                mapTypeControlOptions: {
                    mapTypeIds: ['Styled']
                },
                zoom: 14,
                scrollwheel: false,
                panControl: false,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                overviewMapControl: false,
                mapTypeId: 'Styled'
            };

            map = new google.maps.Map($document.find('#contact-map')[0], myOptions);
            var styledMapType = new google.maps.StyledMapType(map_style, {name: 'Styled'});
            map.mapTypes.set('Styled', styledMapType);
            codeAddress();
        }

        // set banner url
        function setBanner() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'banner') {
                    vm.banner = IMAGE_ABS_URL + section_images[i].url;
                    break;
                }
            }
        }

        // set section title, subtitle, description
        function setSectionText() {
            for (var i = 0; i < section_content.length; i++) {
                switch (section_content[i].name) {
                    case 'title':
                    vm.section_text.title = section_content[i].content;
                    break;
                    case 'contact_info':
                    vm.contact_info = section_content[i].content;
                    break;
                }
            }
        }

        // setup registration form
        function setupRegForm() {
            $timeout(function() {
                angular.element('.open-popup-link').magnificPopup({
                    type: 'inline',
                    midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
                });
            });
        }
    }
})();

(function() {
  'use strict';

  angular
  .module('livExtendedStay')
  .controller('CLVGroupController', CLVGroupController);

  /** @ngInject */
  function CLVGroupController(IMAGE_ABS_URL, sectionData) {
    var vm = this;

    // model
    var section_content = sectionData.section_content;
    var section_images = sectionData.section_images;
    var section_filters = sectionData.section_filters;
    var section_points = sectionData.section_points;

    // view
    vm.banner = '';
    vm.questions = [];
    vm.section_text = {
      title: '',
      subtitle: '',
      description: ''
    };

    // functions
    init();

    function init() {
      setBanner();
      setSectionText();
    }

    // set banner url
    function setBanner() {
      for (var i = 0; i < section_images.length; i++) {
        if (section_images[i].type === 'banner') {
          vm.banner = IMAGE_ABS_URL + section_images[i].url;
          break;
        }
      }
    }

    // set section title, subtitle, description
    function setSectionText() {
      for (var i = 0; i < section_content.length; i++) {
        switch (section_content[i].name) {
          case 'title':
            vm.section_text.title = section_content[i].content;
            break;
          case 'subtitle':
            vm.section_text.subtitle = section_content[i].content;
            break;
          case 'description':
            vm.section_text.description = section_content[i].content;
            break;
          case 'secondary_title':
            vm.liv_local.title = section_content[i].content;
            break;
          case 'secondary_description':
            vm.liv_local.description = section_content[i].description;
            break;
        }
      }
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('livExtendedStay')
  .controller('CERCController', CERCController);

  /** @ngInject */
  function CERCController(IMAGE_ABS_URL, sectionData) {
    var vm = this;

    // model
    var section_content = sectionData.section_content;
    var section_images = sectionData.section_images;
    var section_filters = sectionData.section_filters;
    var section_points = sectionData.section_points;

    // view
    vm.banner = '';
    vm.questions = [];
    vm.section_text = {
      title: '',
      subtitle: '',
      description: ''
    };

    // functions
    init();

    function init() {
      setBanner();
      setSectionText();
    }

    // set banner url
    function setBanner() {
      for (var i = 0; i < section_images.length; i++) {
        if (section_images[i].type === 'banner') {
          vm.banner = IMAGE_ABS_URL + section_images[i].url;
          break;
        }
      }
    }

    // set section title, subtitle, description
    function setSectionText() {
      for (var i = 0; i < section_content.length; i++) {
        switch (section_content[i].name) {
          case 'title':
            vm.section_text.title = section_content[i].content;
            break;
          case 'subtitle':
            vm.section_text.subtitle = section_content[i].content;
            break;
          case 'description':
            vm.section_text.description = section_content[i].content;
            break;
          case 'secondary_title':
            vm.liv_local.title = section_content[i].content;
            break;
          case 'secondary_description':
            vm.liv_local.description = section_content[i].description;
            break;
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('livExtendedStay')
    .controller('BookingController', BookingController);

  /** @ngInject */
  function BookingController($document, $timeout) {
    var vm = this;

    vm.ready = false

    init();

    function init() {
      waitToShowWidget();
    }

    // show liv marker
    function waitToShowWidget() {
      // console('Geocode was not successful for the following reason: ' + status);
      $timeout(function () {
        angular.element('#widget_link').addClass('loaded');
        vm.ready = true;
      }, 1900);
    }
  }
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .controller('AmenitiesController', AmenitiesController);

    /** @ngInject */
    function AmenitiesController(IMAGE_ABS_URL, sectionData) {
        var vm = this;

        // model
        var section_content = sectionData.section_content;
        var section_images = sectionData.section_images;

        // view
        vm.amenities_cards = [];
        vm.section_text = {
            title: '',
            subtitle: '',
            description: ''
        };

        // variables

        // functions
        init();

        function init() {
            setBanner();
            setSectionText();
            setCards();
        }

        // set section banner
        function setBanner() {
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'banner') {
                    vm.banner = IMAGE_ABS_URL + section_images[i].url;
                    break;
                }
            }
        }

        // set amenities cards
        function setCards() {
            var amenities_cards = [];
            for (var i = 0; i < section_images.length; i++) {
                if (section_images[i].type === 'card') {
                    amenities_cards.push(section_images[i]);
                    var last = amenities_cards.length - 1;
                    amenities_cards[last].url = IMAGE_ABS_URL + amenities_cards[last].url;
                }
            }

            // sort cards by imageset_id
            amenities_cards.sort(function(a,b) {
                return parseInt(a.imageset_id) - parseInt(b.imageset_id);
            });

            vm.amenities_cards = amenities_cards;
        }

        // set section title, subtitle, description
        function setSectionText() {
            for (var i = 0; i < section_content.length; i++) {
                switch (section_content[i].name) {
                    case 'title':
                        vm.section_text.title = section_content[i].content;
                        break;
                    case 'subtitle':
                        vm.section_text.subtitle = section_content[i].content;
                        break;
                    case 'description':
                        vm.section_text.description = section_content[i].content;
                        break;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('googleService', [])
    .factory('googleService', googleService);

    function googleService($http) {
        return {
            getGoogleStars: function() {
                return $http.get('https://www.livottawa.com/extended-stay/api/get_rating.php')
                .then(function(res) { return res.data; });
            },
            getGoogleReviews: function() {
                return $http.get('https://www.livottawa.com/extended-stay/api/get_review_numbers.php')
                .then(function(res) { return res.data; });
            }
        };
    }

})();

(function() {
    'use strict';

    angular
    .module('contentService', [])
    .factory('contentService', contentService);

    function contentService($http, PROJECT_ID) {
        return {
            getSectionContent: function (section, id) {
                var content_id = PROJECT_ID;
                if (id) content_id = id;

                var url = 'https://adhocstudio.ca/feed/pdo/get_section_content?id=' + content_id + '&section_name=' + section + '&r=' + Math.random() * 100;

                return $http.get(url, {'Cache-Control': 'no-cache'}).then(function(res) {
                    return res.data;
                });
            }
        };
    }

})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .directive('regform', RegForm);

    /** @ngInject */
    function RegForm() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/regform/regform.html'
        };

        return directive;
    }

})();

/* New way of setting title */
/*eslint angular/di: [2,"array"] */

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .directive('title', ['$rootScope', '$timeout', TitleDirective]);

    function TitleDirective($rootScope, $timeout) {
        return {
            link: function() {
                var listener = function(event, toState) {
                    $timeout(function() {
                        /*eslint angular/on-watch: 0*/
                        $rootScope.title = toState.title ? toState.title
                        : 'LIV Extended Stay';
                    });
                };
                
                /*eslint angular/on-watch: 0*/
                $rootScope.$on('$stateChangeSuccess', listener);
            }
        };
    }
})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .directive('navbar', Navbar)
    .filter('trustHTML', htmlFilter);

    /** @ngInject */
    function Navbar() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            controller: NavbarController,
            controllerAs: 'nav',
            bindToController: true
        };

        return directive;
    }

    // trust html filter
    function htmlFilter($sce) {
        return function(text) {
            return $sce.trustAsHtml(text);
        };
    }

    /** @ngInject */
    function NavbarController($location, $rootScope, $scope, $state, $timeout, $window, contentService, googleService, PROJECT_SECTIONS) {
        var vm = this;

        // model
        vm.model = {};
        vm.sections = PROJECT_SECTIONS;

        // views
        vm.current_section = $state.current.name;
        vm.email = '';
        vm.phone = '';
        vm.reviews = '';
        vm.stars = '';

        // variables
        vm.navCollapsed = true;
        vm.shrinkLogo = false;

        // functions
        vm.toggleNavbar = toggleNavbar;

        init();

        function init() {
            getStars();
            getSectionContent();
            initLogoBehaviour();

            /*eslint angular/on-watch: 0*/
            $rootScope.$on("$stateChangeSuccess", function() {
                vm.current_section = $state.current.name;
            });
        }

        // get number of google reviews
        function getReviews() {
            googleService.getGoogleReviews().then(function(data) {
                vm.reviews = data.replace('<span>','').replace('</span>','');
            });
        }

        // populate model
        function getSectionContent() {
            contentService.getSectionContent('Home').then(function(data) {
                var section_content = data.section_content;
                for (var i = 0; i < section_content.length; i++) {
                    if (section_content[i].name === 'header_email') {
                        vm.email = section_content[i].content;
                    } else if (section_content[i].name === 'header_phone') {
                        vm.phone = {
                            url: 'tel: +' + removeSpecial(section_content[i].content),
                            number: section_content[i].content
                        };
                    }
                }
            });
        }

        // get google reviews
        function getStars() {
            googleService.getGoogleStars().then(function(data) {
                vm.stars = data.result.rating;
                initStars();
            });
        }

        // initialize logo behaviour on scroll
        function initLogoBehaviour() {
            $timeout(function() {
                angular.element($window).bind('scroll', function() {
                    if (this.pageYOffset >= 200) {
                        angular.element('navbar').addClass('shrink');
                    } else {
                        angular.element('navbar').removeClass('shrink');
                    }
                });
                $scope.$digest();
            });
        }

        // google review stars
        function initStars() {
            var stars = angular.element('.stars');
            for (var i = 0; i < stars.length; i++) {
                var val = vm.stars;
                var size = Math.max(0, (Math.min(5, val))) * 13.5;
                var span = angular.element('<span />').width(size);
                angular.element(stars[i]).html(span);
            }
        }

        // remove special characters from phone number
        function removeSpecial(number) {
            var new_num = number.replace('(', '').replace(')','').replace(' ', '').replace('-','');
            return 1 + '' + new_num;
        }

        // toggle navbar
        function toggleNavbar() {
            vm.navCollapsed = !vm.navCollapsed;
            if (vm.navCollapsed) {
                angular.element('body').removeClass('overflow-hidden');
            } else {
                angular.element('body').addClass('overflow-hidden');
            }
        }

    }

})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .directive('footer', Footer);

    /** @ngInject */
    function Footer() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/footer/footer.html',
            controller: FooterController,
            controllerAs: 'footer',
            bindToController: true
        };

        return directive;
    }

    /** @ngInject */
    function FooterController(contentService, PROJECT_SECTIONS) {
        var vm = this;

        // views
        vm.contact_email = '';
        vm.contact_phone = '';
        vm.date = new Date().getFullYear();
        vm.sections = [];
        vm.social_media = [
            {
                image: 'assets/images/yt-icon.png', name: 'YouTube',
                url: 'https://plus.google.com/+LIVApartmentsOttawa/videos'
            },
            {
                image: 'assets/images/fb-icon.png', name: 'Facebook',
                url: 'https://www.facebook.com/LIVOttawa'
            },
            {
                image: 'assets/images/gplus-icon.png', name: 'Google+',
                url: 'https://plus.google.com/+LIVApartmentsOttawa/about?hl=en'
            },
            {
                image: 'assets/images/ig-icon.png', name: 'Instagram',
                url: 'https://instagram.com/livottawa/'
            },
            {
                image: 'assets/images/pin-icon.png', name: 'Pinterest',
                url: 'https://www.pinterest.com/LIVOttawa/'
            },
            {
                image: 'assets/images/tw-icon.png', name: 'Twitter',
                url: 'https://twitter.com/LIVOttawa/'
            },
            {
                image: 'assets/images/blog-icon.png', name: 'Blog',
                url: 'http://blog.livottawa.com/'
            }
        ];

        init();

        function init() {
            // setup sections so it shows up in groups of 4
            var section_group = [];
            for (var i = 0; i < PROJECT_SECTIONS.length; i++) {
                if (i % 4 === 0 && i !== 0) {
                    // push section group to vm.sections and clear array
                    section_group.push(PROJECT_SECTIONS[i]);
                    vm.sections.push(section_group);
                    section_group = [];
                } else {
                    section_group.push(PROJECT_SECTIONS[i]);
                }
            }
            vm.sections.push(section_group);

            // Adding CERC
            vm.sections[0].splice(5, 0, {
              name: 'CERC',
              url: 'CERC'
            });
            
            getContactInfo();
        }

        // populate phone number and email address
        function getContactInfo() {
            contentService.getSectionContent('Home').then(function(data) {
                var section_content = data.section_content;
                for (var i = 0; i < section_content.length; i++) {
                    if (section_content[i].name === 'header_email') {
                        vm.contact_email = section_content[i].content;
                    } else if (section_content[i].name === 'header_phone') {
                        vm.contact_phone = {
                            url: 'tel: +' + removeSpecial(section_content[i].content),
                            number: section_content[i].content
                        };
                    }
                }
            });
        }

        // remove special characters from phone number
        function removeSpecial(number) {
            var new_num = number.replace('(', '').replace(')','').replace(' ', '').replace('-','');
            return 1 + '' + new_num;
        }
    }

})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .directive('background', BackgroundDirective);

    function BackgroundDirective() {
        return function (scope, element, attrs) {
            var url = attrs.background;
            element.css({
                'background-image': 'url("' + url + '")',
                'background-size' : 'cover'
            });
        };
    }

})();

/* eslint-disable */

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .run(runBlock);

    /** @ngInject */
    function runBlock($document, $location, $log, $rootScope, $state, $timeout, $window) {
        $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;

        $rootScope.$on("$stateChangeSuccess", function(event, toState) {
            $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
            $timeout(function() {
                angular.element('.body-content').addClass('loaded');

                // load banner image
                var bg_url = angular.element('.banner').attr('background');
                angular.element('<img/>').attr('src', bg_url).load(function() {
                    angular.element(this).remove(); // prevent memory leaks as @benweet suggested
                    angular.element('.banner').addClass('loaded');
                });

                if (toState.name === 'home') {
                  $timeout(function() {
                    angular.element('.body-content').addClass('main');
                  }, 350);
                }
            }, 250);

            if (toState.name === 'CLVGroupReviews') {
              $('meta[name="description"]').attr('content', 'CLV Group is a large real estate company that has served much of the Canadian housing market for 50 years and has a portfolio of properties spanning more than 20 cities throughout Ontario and Quebec.  Read these helpful reviews of CLV Group to learn more about the property management company.');
            } else if (toState.name === 'CLVGroup') {
              $('meta[name="description"]').attr('content', 'CLV Group\'s LIV Extended Stay is Ottawa\'s ideal home away from home for the traveling professional offering fully furnished suites beyond compare equipped with all the conveniences of home.');
            } else {
              $('meta[name="description"]').attr('content', 'LIV Extended Stay is Ottawa\'s ideal home away from home for the traveling professional. We offer fully furnished suites equipped with all the conveniences you expect in a home, plus unmatched amenities to provide you with an endless array of possibilities.');
            }

            gtag('config', 'AW-1070903942', { 'page-path': $location.url() });
            $window.ga('send', 'pageview', { page: $location.url() });
        });

        $rootScope.$on('$stateChangeStart', function() {
            angular.element('.body-content').removeClass('loaded');
        });

        /*eslint angular/on-watch: 0*/
        $rootScope.$on('$stateChangeError',
        function (event, toState, toParams, fromState, fromParams, error) {
            $log.log('$stateChangeError', error);
        });

        backToTop();
    }

    function backToTop() {
        // Show or hide the sticky footer button
        $(window).scroll(function() {
            if ($(this).scrollTop() > 200) {
                $('.go-top').fadeIn(200);
                $('.promotions-button').addClass('top');
            } else {
                $('.go-top').fadeOut(200);
                $('.promotions-button').removeClass('top');
            }
        });

        // Animate the scroll to top
        $('.go-top').click(function(event) {
            event.preventDefault();
            $('html, body').animate({scrollTop: 0}, 300);
        });
    }

})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .config(routerConfig);

    /** @ngInject */
    function routerConfig($locationProvider, $stateProvider, $urlMatcherFactoryProvider, $urlRouterProvider) {
        $urlMatcherFactoryProvider.caseInsensitive(true);

        $stateProvider
        // home
        .state('home', {
            url: '/',
            templateUrl: 'app/sections/main/main.html',
            title: 'LIV Extended Stay',
            controller: 'MainController',
            controllerAs: 'vm',
            resolve: { /* @ngInject */
                sectionData: function (contentService) {
                    return getSectionData('home', contentService);
                }
            }
        })

        // suites & rates
        .state('suites', {
            url: '/suites',
            templateUrl: 'app/sections/suites/suites.html',
            title: 'LIV Extended Stay - Suites & Rates',
            controller: 'SuitesController',
            controllerAs: 'vm',
            resolve: { /* @ngInject */
                sectionData: function (contentService) {
                    return getSectionData('suites', contentService);
                }
            }
        })

        // amenities
        .state('amenities', {
            url: '/amenities',
            templateUrl: 'app/sections/amenities/amenities.html',
            title: 'LIV Extended Stay - Amenities',
            controller: 'AmenitiesController',
            controllerAs: 'vm',
            resolve: { /* @ngInject */
                sectionData: function (contentService) {
                    return getSectionData('amenities', contentService);
                }
            }
        })

        // services
        .state('services', {
            url: '/services',
            templateUrl: 'app/sections/services/services.html',
            title: 'LIV Extended Stay - Services',
            controller: 'ServicesController',
            controllerAs: 'vm',
            resolve: { /* @ngInject */
                sectionData: function (contentService) {
                    return getSectionData('services', contentService);
                }
            }
        })

        // location
        .state('location', {
            url: '/location',
            templateUrl: 'app/sections/location/location.html',
            title: 'LIV Extended Stay - Location',
            controller: 'LocationController',
            controllerAs: 'vm',
            resolve: { /* @ngInject */
                sectionData: function (contentService) {
                    return getSectionData('location', contentService);
                },
                locationData: function (contentService) {
                    return getSectionData('neighbourhood', contentService, 243);
                }
            }
        })

        // local partners
        .state('localpartners', {
            url: '/local_partners',
            templateUrl: 'app/sections/location/local_partners/local_partners.html',
            title: 'LIV Extended Stay - Local Partners',
            controller: 'LocalPartnersController',
            controllerAs: 'vm',
            resolve: {
                sectionData: function (contentService) {
                    return getSectionData('neighbourhood', contentService, 243);
                }
            }
        })

        // gallery
        .state('gallery', {
            url: '/gallery',
            templateUrl: 'app/sections/gallery/gallery.html',
            title: 'LIV Extended Stay - Gallery',
            controller: 'GalleryController',
            controllerAs: 'vm',
            resolve: { /* @ngInject */
                sectionData: function (contentService) {
                    return getSectionData('gallery', contentService);
                },
                galleryImages: function (contentService) {
                    return getSectionData('gallery', contentService, 243);
                }
            }
        })

        // faqs
        .state('faqs', {
            url: '/faqs',
            templateUrl: 'app/sections/faqs/faqs.html',
            title: 'LIV Extended Stay - FAQs',
            controller: 'FAQController',
            controllerAs: 'vm',
            resolve: { /* @ngInject */
                sectionData: function (contentService) {
                    return getSectionData('faqs', contentService);
                }
            }
        })

        // contact
        .state('contact', {
            url: '/contact',
            templateUrl: 'app/sections/contact/contact.html',
            title: 'LIV Extended Stay - Contact',
            controller: 'ContactController',
            controllerAs: 'vm',
            resolve: { /* @ngInject */
                sectionData: function (contentService) {
                    return getSectionData('contact', contentService);
                }
            }
        })

        // reviews
        .state('reviews', {
            url: '/reviews',
            templateUrl: 'app/sections/reviews/reviews.html',
            title: 'LIV Extended Stay - Reviews',
            controller: 'ReviewsController',
            controllerAs: 'vm',
            resolve: { /* @ngInject */
                sectionData: function (contentService) {
                    return getSectionData('reviews', contentService);
                }
            }
        })

        // terms and conditions
        .state('terms', {
            url: '/terms',
            templateUrl: 'app/sections/terms/terms.html',
            title: 'LIV Extended Stay - Terms and Conditions',
            controller: 'TermsController',
            controllerAs: 'vm',
            resolve: { /* @ngInject */
                sectionData: function (contentService) {
                    return getSectionData('suites', contentService);
                }
            }
        })

        // Meetings and Events
        .state('meetings', {
          url: '/meetings',
          templateUrl: 'app/sections/meetings/meetings.html',
          title: 'LIV Extended Stay - Meetings & Events',
          controller: 'MeetingsController',
          controllerAs: 'vm',
          resolve: {
            /* @ngInject */
            sectionData: function (contentService) {
              return getSectionData('meetings', contentService);
            }
          }
        })

        .state('booking', {
            url: '/booking',
            templateUrl: 'app/sections/booking/booking.html',
            title: 'LIV Extended Stay - Reserve Now',
            controller: 'BookingController',
            controllerAs: 'vm',
            resolve: {
            }
        })

        .state('CERC', {
          url: '/CERC',
          templateUrl: 'app/sections/cerc/cerc.html',
          controller: 'CERCController',
          controllerAs: 'vm',
          title: 'LIV Extended Stay - CERC',
          resolve: {
            sectionData: function (contentService) {
              return getSectionData('CERC', contentService);
            }
          }
        })

        .state('CLVGroup', {
          url: '/CLVGroup',
          templateUrl: 'app/sections/clv-group/clv-group.html',
          controller: 'CLVGroupController',
          controllerAs: 'vm',
          title: 'Liv Extended Stay Ottawa | CLV Group',
          resolve: {
            sectionData: function (contentService) {
              return getSectionData('CLV Group', contentService);
            }
          }
        })

        .state('CLVGroupReviews', {
          url: '/CLVGroupReviews',
          templateUrl: 'app/sections/clv-reviews/clv-reviews.html',
          controller: 'CLVGroupReviewsController',
          controllerAs: 'vm',
          title: 'Liv Extended Stay Ottawa | CLV Group Reviews',
          resolve: {
            sectionData: function (contentService) {
              return getSectionData('CLV Reviews', contentService);
            }
          }
        })

        ;

        $urlRouterProvider.otherwise('/');
        $locationProvider.html5Mode(true);
    }

    getSectionData.$inject = ['contentService'];
    function getSectionData(section, contentService, id) {
        if (!id) {
            return contentService.getSectionContent(section).then(function(data) {
                return data;
            });
        } else {
            return contentService.getSectionContent(section, id).then(function(data) {
                return data;
            });
        }
    }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('livExtendedStay')
    .constant('moment', moment)
    .constant('PROJECT_ID', 363)
    .constant('IMAGE_ABS_URL', 'http://adhocstudio.ca/dev/NewProjectDataManagement/projectManager/')
    .constant('PROJECT_SECTIONS',[
        { name: 'Suites & Rates', navName: 'Suites & Rates', url: 'suites' },
        { name: 'Amenities', navName: 'Amenities', url: 'amenities' },
        { name: 'Services', navName: 'Services', url: 'services' },
        // { name: 'Gallery', navName: '<span class="nav-padding">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>Gallery<span class="nav-padding">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>', url: 'gallery' },
        { name: 'Gallery', navName: 'Gallery', url: 'gallery' },
        { name: '<img src="assets/images/logo.png" class="logo" />', navName: '<img src="assets/images/logo.png" class="logo" />',url: 'home' },
        { name: 'Meetings & Events', navName: 'Meetings & Events', url: 'meetings' },
        { name: 'Location', navName: 'Location', url: 'location' },
        { name: 'FAQs', navName: 'FAQs', url: 'faqs' },
        { name: 'Contact', navName: 'Contact', url: 'contact' },
        { name: 'Reviews', navName: 'Reviews', url: 'reviews' }
    ]);

})();

(function() {
    'use strict';

    angular
    .module('livExtendedStay')
    .config(config);

    /** @ngInject */
    function config($logProvider) {
        // Enable log
        $logProvider.debugEnabled(true);

    }
    
})();

angular.module("livExtendedStay").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/footer/footer.html","<style>.footer-grey {\r\n    background-color: #ececef;\r\n    padding: 15px 0 0;\r\n}\r\n\r\n.footer-white-title {\r\n    text-transform: uppercase;\r\n    color: #231f20;\r\n    font-size: 22px;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.site-map-links {\r\n    font-size: 16px;\r\n    line-height: 1.75;\r\n    letter-spacing: 0.5px;\r\n    color: #231f20;\r\n    text-decoration: none !important;\r\n}\r\n\r\n.site-map-links:hover {\r\n    color: #c3d600;\r\n    text-decoration: none;\r\n}\r\n\r\n.footer-contact {\r\n    line-height: 2;\r\n    font-size: 14px;\r\n}\r\n\r\n.footer-contact a {\r\n    color: #36454f;\r\n}\r\n\r\n.footer-contact a:hover {\r\n    color: #231f20;\r\n}\r\n\r\n.footer-contact-row {\r\n    padding: 10px 0 20px 0;\r\n}\r\n\r\n.footer-eoe {\r\n    padding: 10px 0;\r\n    border-top: 5px solid #c3d600;\r\n}\r\n\r\n.adhoc {\r\n    color: #231f20;\r\n}\r\n\r\n.adhoc:hover {\r\n    color: #231f20;\r\n    font-weight: 700;\r\n}\r\n\r\n.footer-black {\r\n    background-color: #231f20;\r\n    color: #ffffff;\r\n    padding: 10px 0;\r\n}\r\n\r\n.social-media {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.social-media>a {\r\n    margin-right: 10px;\r\n}\r\n\r\n.footer-experienced {\r\n    font-size: 12px;\r\n    padding-left: 5px;\r\n}\r\n\r\n.clv-group {\r\n    text-align: right;\r\n}\r\n\r\n.clv-group-div, .liv-icon {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    margin-left: 15px;\r\n    font-size: 12px;\r\n}\r\n\r\n.footer-link {\r\n    color: #ffffff !important;\r\n    outline: none;\r\n    border: none;\r\n}\r\n\r\n.footer-link:hover {\r\n    color: #c3d600 !important;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n    .footer-white-title {\r\n        text-align: center;\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .site-map-rows {\r\n        margin-bottom: 20px;\r\n    }\r\n\r\n    .footer-experienced, .eoe-text,\r\n    .social-media, .clv-group {\r\n        text-align: center;\r\n    }\r\n\r\n    .social-media>a:nth-last-child(1) {\r\n        margin-right: 0;\r\n    }\r\n\r\n    .footer-sections {\r\n        text-align: center;\r\n    }\r\n\r\n    .footer-contact {\r\n        text-align: center;\r\n    }\r\n}</style><!-- grey part --><div class=footer-grey><div class=container><div class=\"row footer-contact-row\"><!-- sitemap --><div class=\"col-md-10 col-sm-9 col-xs-12\"><div class=footer-white-title>SITE MAP</div><div class=\"row site-map-rows\"><div class=\"col-md-2 col-sm-4 col-xs-6 footer-sections\" ng-repeat=\"section_group in footer.sections\"><div ng-repeat=\"section in section_group\" ng-if=\"section.url != \'home\' && section.url != \'CERC\'\"><a class=site-map-links ui-sref=\"{{ section.url }}\" ng-bind-html=\"section.name | trustHTML\"></a></div><div ng-if=\"section.url != \'home\' && $index === 0\"><a class=site-map-links ui-sref=CLVGroupReviews>CLV Reviews</a></div><div ng-if=\"section.url != \'home\' && $index === 1\"><a class=site-map-links ui-sref=CERC>CERC</a></div></div></div></div><!-- contact --><div class=\"col-md-2 col-sm-3 col-xs-12 no-padding\"><div class=footer-white-title>visit us</div><div class=footer-contact><div>207 Bell Street North</div><div>Ottawa, ON K1R 0B9</div><div><i class=\"material-icons valign\">phone</i> <a href={{footer.contact_phone.url}} class=valign>{{ footer.contact_phone.number }}</a></div><div class=email-container><i class=\"material-icons valign\">email</i> <a class=valign href=mailto:{{footer.contact_email}}>{{ footer.contact_email }}</a></div></div></div></div><div class=\"row footer-eoe\"><!-- eoe --><div class=\"col-md-10 col-sm-9 col-xs-12 eoe-text\">E. &amp; O.E. Actual finishes may vary.</div><!-- experience by adhoc --><div class=\"col-md-2 col-sm-3 col-xs-12 footer-experienced no-padding\">Experience by <a href=http://adhocstudio.ca class=adhoc>ADhoc Studio</a></div></div></div></div><!-- black part --><div class=footer-black><div class=container><div class=row><!-- social media --><div class=\"col-md-6 col-sm-7 col-xs-12 social-media\"><a href=https://www.youtube.com/user/LIVOttawa target=_blank><img title=YouTube src=assets/images/yt-icon.png> </a><a href=https://www.facebook.com/LIVOttawa target=_blank><img title=Facebook src=assets/images/fb-icon.png> </a><a href=\"https://plus.google.com/106547199182798650359?hl=en\" target=_blank><img title=Google+ src=assets/images/gplus-icon.png> </a><a href=https://instagram.com/livottawa/ target=_blank><img title=Instagram src=assets/images/ig-icon.png> </a><a href=https://www.pinterest.com/LIVOttawa/ target=_blank><img title=Pinterest src=assets/images/pin-icon.png> </a><a href=https://twitter.com/LIVOttawa/ target=_blank><img title=Twitter src=assets/images/tw-icon.png> </a><a href=http://blog.livottawa.com/ target=_blank><img title=Blog src=assets/images/blog-icon.png> </a><a href=https://www.linkedin.com/company/liv-extended-stay target=_blank><img title=Linkedin src=assets/images/lk-icon.png></a></div><!-- clv group --><div class=\"col-md-6 col-sm-5 col-xs-12 clv-group\"><div class=clv-group-div><div><a class=footer-link href=http://www.interrentreit.com/ target=_blank>An <strong>InterRent REIT</strong> Property</a></div><div>Professionally Managed <a ui-sref=CLVGroup class=footer-link><strong>CLV Group</strong></a></div><div>&copy; {{ footer.date }} CLV Group Inc.</div></div><div class=liv-icon><a class=footer-links href=http://livottawa.com target=_blank><img src=assets/images/footer-liv-icon.png></a></div></div></div><hr><div class=row><!-- Logos --><div class=\"col-sm-5 col-sm-offset-0 col-xs-10 col-xs-offset-1 logos-left\"><a href=https://www.cerc.ca/ target=_blank><img src=assets/images/CERC.png></a><p>The Canadian Employee Relocation Council (CERC) is a membership organization whose goal is to provide leadership, services and assistance to members enabling them to effectively serve relocated families by addressing issues that impact workforce mobility both domestically and internationally. CERC has a clearly defined vision of the future and is guided by an important set of values.</p></div><div class=\"col-sm-4 col-sm-offset-3 col-xs-10 col-xs-offset-1 logos-right\"><a href=https://www.chpaonline.org/ target=_blank><img src=assets/images/CHPA.png></a><p>The Corporate Housing Providers Association (CHPA) is a professional trade association exclusively dedicated to supporting corporate housing providers around the world.</p></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<!-- black top bar --><div class=black-bg><div class=container><div class=\"row open-sans\"><!-- google reviews --><div class=\"col-md-4 col-sm-3 align-left white header-left\"><span>{{ nav.stars }}</span> <span class=stars></span> <span class=valign><a class=nav-reviews ui-sref=reviews>Reviews</a></span></div><!-- header contact --><div class=\"col-md-8 col-sm-9 align-right white header-right\"><a class=header-email href=\"mailto:{{ nav.email }}\">{{ nav.email }}</a> <span class=header-divider ng-show=\"nav.phone && nav.email\">|</span> <span class=header-phone ng-show=nav.phone>Call <a href={{nav.phone.url}} class=phone-number>{{ nav.phone.number }}</a> for reservations </span><span><a class=reserve-button href=https://reservations.travelclick.com/102300 target=_blank>Reserve Now</a></span></div><!-- <div class=\"col-md-12 col-sm-12 align-center white header-center corona\">\n                <span>The health and safety of our employees and residents are our top priority. Given the evolving\n                COVID-19, we will temporarily not be accepting Extended Stay reservations.</span>\n            </div> --></div></div></div><!-- <div class=\"red-bg\">\n    <div class=\"container\">\n        <div class=\"row open-sans\">\n            <div class=\"col-md-12 col-sm-12 align-center white header-center corona\">\n                <span>The health and safety of our employees and residents are our top priority.\n                    Given the evolving\n                    COVID-19, we will temporarily not be accepting Extended Stay\n                    reservations.</span>\n            </div>\n        </div>\n    </div>\n</div> --><!-- navbar --><div class=navbar><!-- list 1 --><div class=container-fluid><div class=row><div class=\"col-md-12 align-center navbar-col\"><ul class=navbar-ul><li ng-repeat=\"section in nav.sections\" ng-class=\"{\'no-border\': section.url == \'home\', \'active\': nav.current_section == section.url }\" ng-if=\"section.url != \'reviews\'\"><a ui-sref={{section.url}} ng-bind-html=\"section.navName | trustHTML\" class=desktop-link ng-class=\"{\'logo-link\': section.url == \'home\'}\"></a></li></ul></div></div></div></div><div class=mobile-nav><div class=row><!-- logo --><div class=\"col-xs-6 align-left\"><a ui-sref=home target=_self><img src=assets/images/logo.png class=logo></a></div><!-- menu button --><div class=\"col-xs-6 align-right\"><div id=menu-button ng-click=nav.toggleNavbar()><span class=menu-hb ng-class=\"{\'open\': !nav.navCollapsed }\"></span> <span class=menu-hb ng-class=\"{\'open\': !nav.navCollapsed }\"></span> <span class=menu-hb ng-class=\"{\'open\': !nav.navCollapsed }\"></span></div></div></div></div><div class=nav-dropdown ng-class=\"{\'nav-collapsed\': nav.navCollapsed}\"><ul class=\"mobile-menu uppercase\"><li ng-repeat=\"section in nav.sections\" ng-if=\"section.url != \'home\'\"><a ui-sref=\"{{ section.url }}\" ng-class=\"{\'active\': nav.current_section == section.url }\" ng-click=nav.toggleNavbar() ng-bind-html=\"section.name | trustHTML\"></a></li><li><!--<span><a class=\"menu-reserve-button\" ui-sref=\"booking\" target=\"_blank\">Reserve Now</a></span>--> <span><a class=menu-reserve-button href=https://reservations.travelclick.com/102300 target=_blank>Reserve Now</a></span></li><!-- <li class=\"corona-mobile\">\n            <span>The health and safety of our employees and residents are our top priority. Given the evolving COVID-19, we will temporarily not be accepting Extended Stay reservations.</span>\n        </li> --></ul></div>");
$templateCache.put("app/components/regform/regform.html","<script>function form_submit_complete()\r\n    {\r\n        processingForm = false;\r\n        alert(\"Thank you for registering!\");\r\n        $(\"#form_submit\").prop(\'disabled\', false);\r\n        $(\"#loader\").css(\'display\', \'none\');\r\n    }\r\n\r\n    function add() {\r\n        if ($(this).val() === \'\') {\r\n            $(this).val($(this).attr(\'placeholder\')).addClass(\'placeholder\');\r\n        }\r\n    }\r\n\r\n    function remove() {\r\n        if ($(this).val() === $(this).attr(\'placeholder\')) {\r\n            $(this).val(\'\').removeClass(\'placeholder\');\r\n        }\r\n    }\r\n\r\n    function submitComplete(form)\r\n    {\r\n        $(form).find(\"#form_submit\").prop(\'disabled\', false);\r\n        $(form).find(\"#loader\").css(\'display\', \'none\');\r\n        $(\"#registration_title\").html(\"Thank you for applying!\");\r\n        $(form).css(\'display\', \'none\');\r\n\r\n        ga(\'send\', \'event\', \'registration\', \'complete\');\r\n    }\r\n\r\n    var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\\.)+[A-Z]{2,4}$/i;\r\n    var processingForm = false;\r\n    $(document).ready(function() {\r\n        // Create a dummy element for feature detection\r\n        if (!(\'placeholder\' in $(\'<input>\')[0])) {\r\n\r\n            // Select the elements that have a placeholder attribute\r\n            $(\'input[placeholder], textarea[placeholder]\').blur(add).focus(remove).each(add);\r\n\r\n            // Remove the placeholder text before the form is submitted\r\n            $(\'form\').submit(function() {\r\n                $(this).find(\'input[placeholder], textarea[placeholder]\').each(remove);\r\n            });\r\n        }\r\n\r\n        $(\"#datepicker\").datepicker({\r\n            inline: true,\r\n            showOtherMonths: true,\r\n            dayNamesMin: [\'Sun\', \'Mon\', \'Tue\', \'Wed\', \'Thu\', \'Fri\', \'Sat\'],\r\n        });\r\n\r\n        $(\'#form_register\').validate({\r\n            rules: {\r\n                \'email\': {\r\n                    required: true,\r\n                    email: true\r\n                }\r\n            },\r\n            submitHandler: function(form)\r\n            {\r\n                $(form).find(\"#form_submit\").prop(\'disabled\', true);\r\n                $(form).find(\"#loader\").css(\'display\', \'block\');\r\n\r\n\r\n                var mailchimp_data = {\r\n                    list_id: \"71bff2497b\", // livextendedstay id\r\n                    FNAME: $(\"#fname\").val(),\r\n                    LNAME: $(\"#lname\").val(),\r\n                    EMAIL: $(\"#email_field\").val()\r\n                };\r\n\r\n\r\n                //SUBMIT TO MAILCHIMP\r\n                 $.ajax({\r\n                    type: \'POST\',\r\n                    url: \'http://livottawa.com/curl/registration_mailchimp.php\',\r\n                    data: mailchimp_data,\r\n                    dataType: \'json\',\r\n                    complete: function(data) {\r\n                        //SUBMIT TO ADHOC\r\n                        var data = $(\"#form_register\").serialize();\r\n                        $.ajax({\r\n                            type: \'POST\',\r\n                            url: \'http://livottawa.com/curl/registration.php\',\r\n                            data: data,\r\n                            dataType: \'json\',\r\n                            complete: function(data) {\r\n                                submitComplete(form);\r\n                            }\r\n                        });\r\n                    }\r\n                });\r\n\r\n                return true;\r\n            }\r\n        });\r\n    });\r\n    adhoc_project_id = 363;</script><div id=botbar_popup class=\"green-popup mfp-hide\"><div style=\"margin: 40px\"><center><div id=registration_title>BE PART OF IT!</div><div>Let us know what you\'re looking for.<br>One of our Customer Care Coordinators<br>will contact you with more details promptly.</div><div class=clear></div><form id=form_register autocomplete=off action=http://adhocstudio.ca/register/index.php method=post><div id=form_elements><input id=cookie_input class=form-control type=hidden value=2clu4Y6LYuNA name=cookie><input id=project_id_input class=form-control type=hidden value=363 name=project_id><input class=\"form-control textbox\" name=user_type type=hidden><div class=clear></div><input class=\"form-control textbox required\" id=fname name=fname placeholder=\"first name *\" required><div class=clear></div><input class=\"form-control textbox required\" id=lname name=lname placeholder=\"last name *\" required><div class=clear></div><input class=\"form-control textbox required\" id=email_field name=email placeholder=\"email *\" required><div class=clear></div><input class=\"form-control textbox\" name=field_684 placeholder=\"phone number\"><div class=clear></div><div style=\"margin-bottom: 20px; margin-top: 20px\"><label style=\"float: left;margin-top: 13px\"><b>arrival date:</b></label><input style=\"float: right\" class=\"form-control dateInput\" id=datepicker name=field_685 placeholder=dd/mm/yy><div class=clear></div></div><div style=\"margin-bottom: 20px\"><div style=\"margin-bottom: 15px\"><label style=\"float: left\"><b>bedroom type:</b></label><div class=clear></div></div><input type=checkbox name=field_686 value=\"1 bedroom\" style=\"margin-left: 7px\"> 1 Bedroom <input type=checkbox name=field_686 value=\"1 bedroom + den\" style=\"margin-left: 7px\"> 1 Bedroom + Den<br><input type=checkbox name=field_686 value=\"2 bedroom\" style=\"margin-left: 7px\"> 2 Bedroom <input type=checkbox name=field_686 value=\"2 bedroom + den\" style=\"margin-left: 7px\"> 2 bedroom + Den<br><input type=checkbox name=field_686 value=\"3 bedroom\" style=\"margin-left: 7px\"> 3 Bedroom</div><div class=clear></div><div style=\"margin-bottom: 20px\"><div style=\"margin-bottom: 15px; float: left\"><label style=\"float: left;margin-top: 13px\"><b>How did you hear about LIV?</b></label><div class=clear></div></div><span class=\"custom-dropdown custom-dropdown--white\" style=\"float: right\"><select name=field_687 class=selectInput><option value=--Select-->--Select--</option><option value=Friend>Friend</option><option value=Website>Website</option><option value=\"Social Media\">Social Media</option><option value=\"Search Engine\">Search Engine</option><option value=\"Outdoor Sign\">Outdoor Sign</option><option value=Radio>Radio</option><option value=Newspaper>Newspaper</option><option value=Event>Event</option><option value=Blog>Blog</option><option value=Other>Other</option></select></span><div class=clear></div></div><div style=\"margin-bottom: 20px; font-size: 15px\">* mandatory fields<br></div></div><div style=\"margin-bottom: 20px\"><input name=email_subscription type=checkbox value=y style=\"width: auto\"> Yes, please email me about LIV Extended Stay updates, promotions and events.</div><input id=registration_submit class=\"btn btn-default\" type=submit value=SUBMIT style=cursor:pointer><br><img id=loader src=http://livottawa.com/images/loading2.gif style=\"display:none;padding-top: 15px\"><div class=clear></div></form></center></div></div>");
$templateCache.put("app/sections/amenities/amenities.html","<!-- Amenities Section --><div id=amenities-section><div class=banner background=\"{{ vm.banner }}\"></div><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- subtitle --><div class=subtitle>{{ vm.section_text.subtitle }}</div><!-- description --><div class=description ng-bind-html=\"vm.section_text.description | trustHTML\"></div><!-- Amenities Photos --><div class=\"row amenities-card-row\"><!-- Amenities cards --><div class=\"col-md-4 col-sm-6 amenities-card\" ng-repeat=\"card in vm.amenities_cards\"><div class=amenities-card-container><img ng-src=\"{{ card.url }}\" width=100% height=auto> <span class=amenities-label><span class=card-title ng-bind-html=\"card.title | trustHTML\"></span><br><br><span ng-bind-html=\"card.caption | trustHTML\"></span></span></div></div></div></div></div>");
$templateCache.put("app/sections/booking/booking.html","<div id=booking-section><!-- web rez pro --><script src=//widgets.webrez.com/Widget/jquery-1.9.1.min.js ng-if=vm.ready></script><script src=//widgets.webrez.com/Widget/jquery-ui.js ng-if=vm.ready></script><script src=//widgets.webrez.com/Widget/wrp_calendar_13.js ng-if=vm.ready></script><!-- JS --><script type=text/javascript>// Booking widget setup\n        setup_parameters =\n        {\n            \"hotel_id\":\"1994\",				// required - your WebRezPro hotel id must be entered\n            \"date_format\":\"D M dd, yy\", 	// optional - default is \'DD M dd, yy\'\n            \"default_days_in_advance\":\"0\",	// optional - default is 0 days in advance,\n            \"flag_turnoff_autoload_date\":\"1\" // 0 = arrival and departure dates automatically loaded, 1 = not loaded, default is 0\n        };</script><style type=text/css>.ui-datepicker-prev.ui-corner-all,\n        .ui-datepicker-next.ui-corner-all {\n            height: 10px;\n            width: 10px;\n        }\n\n        .ui-datepicker-prev.ui-state-hover {\n            border-top: 5px solid transparent !important;\n            border-bottom: 5px solid transparent !important;\n            border-left: 5px solid white !important;\n            font-weight: normal;\n            color: #ffffff !important;\n        }\n\n        .ui-datepicker-prev.ui-state-hover {\n            border-top: 5px solid transparent !important;\n            border-bottom: 5px solid transparent !important;\n            border-left: none !important;\n            border-right: 5px solid white !important;\n            font-weight: normal;\n            color: #ffffff !important;\n        }</style><script type=text/javascript>Date.daysBetween = function(date1, date2) {\n            //Get 1 day in milliseconds\n            var one_day=1000*60*60*24;\n\n            // Convert both dates to milliseconds\n            var date1_ms = date1.getTime();\n            var date2_ms = date2.getTime();\n\n            // Calculate the difference in milliseconds\n            var difference_ms = date2_ms - date1_ms;\n\n            // Convert back to days and return\n            return Math.round(difference_ms/one_day);\n        }\n\n        $(\'#widget_link\').submit(function() {\n            var arrival = new Date($(\'[name=\"formatted_date_from\"]\').val());\n            var departure = new Date($(\'[name=\"formatted_date_to\"]\').val());\n            var days_between = Date.daysBetween(arrival, departure);\n            if (days_between < 30) {\n                swal({\n                    title: \'\',\n                    text: \'<p class=\"align-center\">Please note that a minimum of 30 days stay is required to book online. For reservations shorter than 30 days, please call <a href=\"tel: +18555015079\">1-855-501-5079</a> or email <a href=\"mailto:info@livextendedstay.com\">info@livextendedstay.com</a></p>\',\n                    html: true,\n                    allowOutsideClick: true,\n                    confirmButtonColor: \'#c3d600\'\n                });\n                return false;\n            } else {\n                return true;\n            }\n        });</script><div class=\"booking-description align-center\"><p>Please note that a minimum of 30 days stay is required to book online.<br>For reservations shorter than 30 days, please call <a href=tel:+18555015079>1-855-501-5079</a> or email <a href=mailto:info@livextendedstay.com>info@livextendedstay.com</a></p></div><div class=\"container align-center\"><form id=widget_link action=\"\"><input type=hidden name=table> <input type=hidden name=hotel_id> <input type=hidden name=listing_id> <input type=hidden name=mode> <input type=hidden name=command> <input type=hidden name=nextcommand><div class=\"row widget-row\"><!-- SUITE TYPE --><div class=\"col-md-2 col-xs-12\"><select name=num_beds id=num_beds><option value=\"\" disabled selected># OF BEDROOMS</option><option value=\"\">1 OR MORE BEDROOMS</option><option value=2>2 OR MORE BEDROOMS</option></select></div><!-- ARRIVAL DATE --><div class=\"col-md-2 col-xs-12\"><input name=formatted_date_from id=formatted_date_from size=20 value=ARRIVAL readonly> <input type=hidden name=date_from id=date_from></div><!-- DEPARTURE DATE --><div class=\"col-md-2 col-xs-12\"><input name=formatted_date_to id=formatted_date_to size=20 value=DEPARTURE readonly> <input type=hidden name=date_to id=date_to></div><!-- NUM OF ADULTS --><div class=\"col-md-2 col-xs-12\"><select name=num_adults id=num_adults><option value=\"\" disabled selected># OF ADULTS</option><option value=1>1</option><option value=2>2</option><option value=3>3</option><option value=4>4</option></select></div><div class=\"col-md-2 twelve\"><input type=hidden name=fake_incomingcheckbox value=searchfor_petsallowed><select name=searchfor_petsallowed><option value=\"\" disabled selected>Pets</option><option value=\"\">NO PREFERENCE</option><option value=1>YES</option></select></div><!-- SUBMIT BUTTON --><div class=\"col-md-2 col-xs-12\"><input class=availability-button type=submit value=AVAILABILITY></div></div></form></div><div class=\"booking-policy align-center\"><a ui-sref=terms>Policies, terms, and conditions</a></div></div>");
$templateCache.put("app/sections/cerc/cerc.html","<!-- CERC Section --><div id=cerc-section><div class=banner background=\"{{ vm.banner }}\"></div><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- subtitle --><div class=subtitle>{{ vm.section_text.subtitle }}</div><!-- cerc info --><div class=description ng-bind-html=\"vm.section_text.description | trustHTML\"></div></div></div>");
$templateCache.put("app/sections/clv-group/clv-group.html","<!-- CERC Section --><div id=clv-group-section><div class=banner background=\"{{ vm.banner }}\"></div><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- subtitle --><div class=subtitle>{{ vm.section_text.subtitle }}</div><!-- cerc info --><div class=description ng-bind-html=\"vm.section_text.description | trustHTML\"></div></div></div>");
$templateCache.put("app/sections/clv-reviews/clv-reviews.html","<!-- CERC Section --><div id=clv-reviews-section><div class=banner background=\"{{ vm.banner }}\"></div><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- subtitle --><div class=subtitle>{{ vm.section_text.subtitle }}</div><!-- cerc info --><div class=description ng-bind-html=\"vm.section_text.description | trustHTML\"></div></div></div>");
$templateCache.put("app/sections/contact/contact.html","<!-- Contact Section --><div id=contact-section><div class=banner background=\"{{ vm.banner }}\"></div><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- subtitle --><div class=subtitle>{{ vm.section_text.subtitle }}</div><!-- contact info --><div class=contact-info ng-bind-html=\"vm.contact_info | trustHTML\"></div></div><!-- contact map --><div id=contact-map></div><regform></regform></div>");
$templateCache.put("app/sections/faqs/faqs.html","<!-- FAQs Section --><div id=faqs-section><div class=banner background=\"{{ vm.banner }}\"></div><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- subtitle --><div class=subtitle>{{ vm.section_text.subtitle }}</div><div class=questions><div class=faq-section ng-repeat=\"section in vm.questions\"><div class=faq-section-title>{{ section.title }}</div><div class=faq-question ng-repeat=\"question in section.questions\"><div class=faq-q>Q: <span ng-bind-html=\"question.q | trustHTML\"></span></div><div class=faq-a>A: <span ng-bind-html=\"question.a | trustHTML\"></span></div></div></div></div></div></div>");
$templateCache.put("app/sections/gallery/gallery.html","<!-- Gallery Section --><div id=gallery-section><i class=image-tooltip data-toggle=tooltip data-placement=left title=\"Click to Zoom\" data-animation=false data-trigger=manual></i><div class=banner background=\"{{ vm.banner }}\"></div><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- subtitle --><div class=subtitle>{{ vm.section_text.subtitle }}</div><!-- description --><div class=description ng-bind-html=\"vm.section_text.description | trustHTML\"></div></div><!-- videos --><div class=gallery-videos><div class=\"video-title align-center\">videos</div><div class=container><slick class=video-slick settings=vm.slickConfig><div ng-repeat=\"video in vm.videos\" ng-click=vm.selectVideo($index)><img class=video ng-src=\"{{ video.thumb_url }}\"></div></slick></div></div><!-- images --><div class=\"filter-container align-center\"><button class=filters ng-class=\"{\'active\': vm.current_filter == filter.id}\" ng-repeat=\"filter in vm.filters\" ng-click=vm.selectFilter(filter.id)>{{ filter.name }}</button></div><div class=gallery-images><div class=row><div class=\"col-md-3 col-sm-6 col-xs-12 no-padding\" ng-repeat=\"image in vm.current_images\"><a href=\"{{ image.url }}\"><img ng-src=\"{{ image.thumb_url }}\" width=100%></a></div></div></div></div>");
$templateCache.put("app/sections/location/location.html","<!-- Location Section --><div id=location-section><div class=banner background=\"{{ vm.banner }}\"></div><!-- title, description, walk score --><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- subtitle --><div class=subtitle>{{ vm.section_text.subtitle }}</div><!-- description --><div class=description ng-bind-html=\"vm.section_text.description | trustHTML\"></div><div class=walk-score-container><div class=row><div class=\"col-md-4 col-sm-4 col-xs-12 walk-score\" ng-repeat=\"score in vm.walk_scores\"><div class=walk-score-image-button background=\"{{ score.image_url }}\"><div class=walk-score-image-label>{{ score.score }}</div></div><div class=walk-score-details><strong ng-bind-html=\"score.title | trustHTML\"></strong><br><span ng-bind-html=\"score.description | trustHTML\"></span></div></div></div></div></div><!-- maps --><div class=map-container><div id=filter-container><p id=filter-label><strong>FILTERS</strong></p><div id=filterBtnsArea class=col-md-8><div class=\"filterBtn col-md-6 col-sm-6 col-xs-6\" ng-repeat=\"(key, filter) in vm.filters\" ng-class=\"{\'active\': vm.current_filter == key }\" ng-click=vm.selectFilter(key)>{{ filter }}</div><div id=clearBtn ng-click=vm.clearFilter()>clear</div></div><div id=filter-word>FILTERS</div></div><!-- google maps --><div id=location-map></div><div class=walk-score-label><a href=\"{{ vm.walk_score_button.url }}\" target=_blank><img ng-src=\"{{ vm.walk_score_button.image_url }}\" class=walk-score-image alt=\"Walk Score of {{ vm.walk_score_button.label }}\"></a></div></div><!-- liv local --><div class=container><div class=\"section-title align-center\"><span class=title-text ng-bind-html=\"vm.liv_local.title | trustHTML\"></span></div><!-- description --><div class=\"description liv-local-description\" ng-bind-html=\"vm.liv_local.description | trustHTML\"></div><!-- key --><div class=keytag><img ng-src=\"{{ vm.keytag }}\" height=200px width=auto></div><div class=partners><div class=row><div class=\"col-md-3 col-sm-6 col-xs-12 partner\" ng-repeat=\"partner in vm.partners\"><span style=\"display: block; border: 1px solid #c3d600\"></span><div><a target=_blank href=\"{{ partner.url }}\"><img ng-src=\"{{ partner.image_url }}\" class=partner-img></a><br><div class=partner-description ng-bind-html=\"partner.description | trustHTML\"></div></div></div></div></div><div class=many-more><a class=many-more-link ui-sref=localpartners><strong>AND MANY MORE!</strong></a></div></div></div>");
$templateCache.put("app/sections/main/main.html","<script src=https://www.youtube.com/iframe_api></script><slick settings=vm.slickConfig><div ng-repeat=\"image in vm.carousel_images\"><img ng-src=\"{{ image }}\"></div></slick><div class=\"container home-container\"><div class=row><div class=\"col-md-offset-2 col-md-8\" ng-bind-html=\"vm.content | trustHTML\"></div></div><!-- video + images --><div class=\"media-row row\"><div class=\"col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12\"><!-- video --><div class=row><div class=\"col-md-8 col-sm-12 col-xs-12\"><div id=yt-container></div><!--<iframe id=\"home-yt\" width=\"100%\" height=\"265\" ng-src=\"{{ vm.video.url }}\" frameborder=\"0\" allowfullscreen=\"allowfullscreen\" volume=\"0\"></iframe>--></div><div class=\"col-md-4 col-sm-12 col-xs-12 media-caption-container\"><div class=media-caption><span class=your>YOUR</span><br><span class=green-home>HOME</span><br>AWAY FROM<br><span class=green-home>HOME</span></div></div></div><!-- images --><div class=\"row images-row\"><div class=\"col-md-3 col-sm-6 col-xs-6\" ng-repeat=\"image in vm.images\"><a href=\"{{ image.url }}\"><img ng-src=\"{{ image.thumb_url }}\" width=100%></a></div></div><div class=home-view-more><a ui-sref=gallery class=view-more-link>View More</a></div></div></div></div><div class=promotions-popup ng-class=\"{\'open\': vm.promotion_view}\" ng-show=vm.promotion><button close ng-click=vm.togglePromotion()><i class=material-icons>&#xE5CD;</i></button><div ng-bind-html=\"vm.promotion | trustHTML\"></div></div><div class=promotions-button ng-show=vm.promotion><button ng-click=vm.togglePromotion();><i class=material-icons>&#xE838;</i></button></div>");
$templateCache.put("app/sections/meetings/meetings.html","<!-- Amenities Section --><div id=meetings-section><div class=banner background=\"{{ vm.banner }}\"></div><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- subtitle --><div class=subtitle>{{ vm.section_text.subtitle }}</div><!-- description --><div class=description ng-bind-html=\"vm.section_text.description | trustHTML\"></div><div class=row><div class=\"col-md-12 col-sm-12 col-xs-12 text-center quote\"><a href=mailto:events@livextendedstay.com><button class=\"brochure-link quote-link\">Get Quote Now</button></a></div></div><!-- Amenities Photos --><div class=\"row meetings-card-row\"><!-- Amenities cards --><div class=\"col-md-4 col-sm-6 meetings-card\" ng-repeat=\"card in vm.amenities_cards\"><div class=meetings-card-container><img ng-src=\"{{ card.url }}\" width=100% height=auto> <span class=meetings-label><span class=card-title ng-bind-html=\"card.title | trustHTML\"></span><br><br><span ng-bind-html=\"card.caption | trustHTML\"></span></span></div></div></div><div class=description ng-bind-html=\"vm.section_text.skyDivider | trustHTML\"></div><!-- Sky Amenities Photos --><div class=\"row meetings-card-row\"><!-- Amenities cards --><div class=\"col-md-4 col-sm-6 meetings-card\" ng-repeat=\"card in vm.amenities_cards_sky\"><div class=meetings-card-container><img ng-src=\"{{ card.url }}\" width=100% height=auto> <span class=meetings-label><span class=card-title ng-bind-html=\"card.title | trustHTML\"></span><br><br><span ng-bind-html=\"card.caption | trustHTML\"></span></span></div></div></div><!-- Keyplate --> <img ng-src=\"{{ vm.keyplate }}\" width=100% height=auto><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.skyTitle }}</span></div><div class=sky-description ng-bind-html=\"vm.section_text.skyDescription | trustHTML\"></div><div class=\"section-list align-left\" ng-bind-html=\"vm.section_text.skyList | trustHTML\"></div></div></div>");
$templateCache.put("app/sections/reviews/reviews.html","<!-- Reviews Section --><div id=reviews-section><div class=banner background=\"{{ vm.banner }}\"></div><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- subtitle --><div class=subtitle>{{ vm.section_text.subtitle }}</div><!-- description --><div class=description ng-bind-html=\"vm.section_text.description | trustHTML\"></div><!-- reviews --><slick class=reviews-slick settings=vm.slickConfig><div class=review ng-repeat=\"review in vm.reviews\"><div class=review-text ng-bind-html=\"review.text | trustHTML\"></div><div class=review-name ng-bind-html=\"review.name | trustHTML\"></div></div></slick></div></div>");
$templateCache.put("app/sections/services/services.html","<!-- Services Section --><div id=services-section><div class=banner background=\"{{ vm.banner }}\"></div><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- subtitle --><div class=subtitle>{{ vm.section_text.subtitle }}</div><!-- description --><div class=description ng-bind-html=\"vm.section_text.description | trustHTML\"></div><!-- Services Photos --><div class=\"row card-row\"><!-- Services cards --><div class=\"col-md-4 col-sm-6 services-card\" ng-repeat=\"card in vm.services_cards\"><div class=services-card-container><img ng-src=\"{{ card.url }}\" width=100% height=auto> <span class=services-label><span class=card-title>{{ card.title }}</span><br><br><span ng-bind-html=\"card.caption | trustHTML\"></span></span></div></div></div></div></div>");
$templateCache.put("app/sections/suites/suites.html","<div id=suites-section><div class=banner background=\"{{ vm.banner }}\"></div><div class=container><!-- Suite Features --><div class=\"section-title align-center\"><span class=title-text>{{ vm.title }}</span></div><div class=\"row feature-icons\"><div class=\"feature-icon col-md-3 col-sm-6 col-xs-6\" ng-repeat=\"feature in vm.features\"><img ng-src={{feature.url}} width=auto height=25px><br><br><span ng-bind-html=\"feature.name | trustHTML\"></span></div></div><br><br><!-- features list --><div ng-bind-html=\"vm.suite_features | trustHTML\"></div><br><div class=\"brochure-container align-center\"><a href=assets/docs/LIV%20Extended%20Stay%20Package%20-%20Web.pdf class=brochure-link download target=_blank>Download Brochure</a></div><br><div class=align-center><div class=mini-divider></div></div><!-- rooms --><div class=row><div class=col-md-6 type=\"{{ room.type }}\" ng-click=vm.showFloorplans(room.type) ng-repeat=\"room in vm.bedrooms\"><div class=suite-types ng-class=\"{\'right\': $index % 2 == 0}\" background=\"{{ room.url }}\"><div class=suite-type><span class=number>{{ room.num }}</span>{{ room.title }}<br><small>Click to view photos</small></div></div><a ng-repeat=\"image in room.images\" href=\"{{ image.url }}\" class=donotshow><img title=\"{{ image.caption }}\" ng-src=\"{{ image.url }}\"></a></div></div><!-- rates --><div class=\"section-title align-center\"><span class=title-text>{{ vm.rates_title }}</span></div><div class=row><div class=\"col-md-6 col-md-offset-3\"><div class=\"row lightgrey-bg\"><div class=\"col-md-6 align-center rates-box\" ng-repeat=\"rate in vm.rates\"><div class=rate-title>{{ rate.type }}</div><div class=rate-description>{{ rate.description }}</div></div><div class=\"col-md-12 align-center rates-description\" ng-bind-html=\"vm.rates_description | trustHTML\"></div><div class=\"col-md-12 suites-terms\"><a ui-sref=terms>Policies, terms, and conditions</a></div></div></div></div></div></div>");
$templateCache.put("app/sections/terms/terms.html","<div id=terms-section><div class=container><div class=row><div class=\"col-xs-12 align-center\"><div class=terms-title>LIV Extended Stay Terms and Conditions</div></div><div class=\"col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12 terms\"><div ng-bind-html=\"vm.terms | trustHTML\"></div></div></div></div></div>");
$templateCache.put("app/sections/location/local_partners/local_partners.html","<!-- Local Partners Section --><div id=local-partners-section><div class=banner background=\"{{ vm.banner }}\"></div><!-- title, description, walk score --><div class=container><!-- title --><div class=\"section-title align-center\"><span class=title-text>{{ vm.section_text.title }}</span></div><!-- description --><div class=description ng-bind-html=\"vm.section_text.description | trustHTML\"></div></div><!-- liv local partners --><div class=container><div class=local-partners><div class=row><div class=\"col-md-6 col-sm-6 col-xs-12\" ng-repeat=\"partner in vm.local_partners\"><div class=row><div class=\"col-md-4 col-sm-12 col-xs-12 partner-logo\" background=\"{{ partner.image_url }}\"><a target=_blank href=\"{{ partner.url }}\" class=partner-url></a></div><div class=\"col-md-8 col-sm-12 col-xs-12\"><div class=partner-text><span ng-bind-html=\"partner.description | trustHTML\" class=valign></span></div></div></div></div></div></div></div></div>");}]);